import { Actions } from 'vuex-smart-module';
import PartnerCompanyState from './state';
import PartnerCompanyGetters from './getters';
import PartnerCompanyMutations from './mutations';
import { OrganizationsService } from '../../../services';

const orgzService = new OrganizationsService();

export default class PartnerCompanyActions extends Actions<
  PartnerCompanyState,
  PartnerCompanyGetters,
  PartnerCompanyMutations,
  PartnerCompanyActions
> {
  async get_partner_service_centers() {
    try {
      const { data } = await orgzService.get_partner_service_centers();

      this.mutations.SET_SERVICE_CENTERS(data);
    } catch (error) {
      console.error(error);
    }
  }
}
